export default "__VITE_ASSET__682cc382__"